var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "11px",
    viewBox: "0 0 17 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5AC5E25B-7E07-4286-8E3D-325C54C63280") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,5 C6.381,5 7.5,3.881 7.5,2.5 C7.5,1.119 6.381,0 5,0 C3.619,0 2.5,1.119 2.5,2.5 C2.5,3.881 3.619,5 5,5 M12,5 C13.381,5 14.5,3.881 14.5,2.5 C14.5,1.119 13.381,0 12,0 C10.619,0 9.5,1.119 9.5,2.5 C9.5,3.881 10.619,5 12,5 M12,6 C13.96,6 15.729,6.808 17,8.105 L17,8.105 L17,11 L12.745,11 C12.262,9.127 11.116,7.52 9.573,6.441 C10.33,6.161 11.146,6 12,6 Z M5,6 C8.17,6 10.845,8.109 11.706,11 L11.706,11 L-8.43769499e-13,11 L-8.43769499e-13,8.105 C1.271,6.808 3.04,6 5,6 Z",
    id: "users-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Users"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "users-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#users-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Users",
    fill: "#485159",
    xlinkHref: "#users-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.86f9b1af380d557e8e3fee0625b14855.svg";
export { ForwardRef as ReactComponent };